let buttonQuantity = document.querySelector(".custom_quntity-text");
let buttonQuantityText = document.querySelector(".custom_quntity-text span");
let listQuntity = document.querySelector(".custom_quntity");
let inputQuntity = document.querySelector(".general_container quantity-input .quantity__input");
let quntityWrapper = document.querySelector(".product-form__quantity");
let productFormButton = document.querySelector(".product-form__buttons");


productFormButton.addEventListener("click", function() {
    setTimeout(() => {
        buttonQuantityText.textContent = 1;
    }, 500);
})



listQuntity.addEventListener("click", function openList(event) {
    event.stopPropagation();
    buttonQuantity.setAttribute("data-open", "false")
    let quantity = event.target.dataset.quntity;
    buttonQuantityText.textContent = quantity;
    inputQuntity.value = quantity;
    if (inputQuntity.value >= 10) {
        quntityWrapper.style.display = "block"
        buttonQuantity.remove();
    } 
    changeMaxHeight(listQuntity,false)
})
buttonQuantity.addEventListener("click", function (event) {
    event.stopPropagation();
    if ( buttonQuantity.getAttribute("data-open") === "true") {
        buttonQuantity.setAttribute("data-open", "false")
        changeMaxHeight(listQuntity,false)
    } else {
        changeMaxHeight(listQuntity,true)
        buttonQuantity.setAttribute("data-open", "true")
    }
})

window.addEventListener("click", function () {
    buttonQuantity.setAttribute("data-open", "false");
    changeMaxHeight(listQuntity,false)
})


function changeMaxHeight(selector, flag) {
    selector.style.maxHeight = (flag ? selector.scrollHeight : 0) + "px";
}
